@if (preset() || bi_icon()) {
  <div [class]="['root-container', getIcon().type, size()]">
    <i [class]="['bi', getIcon().icon]"></i>
  </div>
}
